<div class="container mx-auto max-w-lg px-4 py-16 lg:px-0">
  <div class="py-2">
    <h1 class="text-center">Log In to RigShare</h1>
    {{ this.infoMessage }}

    <div class="mt-4 empty:hidden">
      <app-alert *ngIf="errorMessage" class="mb-2" type="danger">
        {{ errorMessage }}
      </app-alert>

      <app-alert *ngIf="successMessage" class="mb-2" type="success">
        {{ successMessage }}
      </app-alert>

      <app-alert *ngIf="infoMessage" class="mb-2" type="info">
        {{ infoMessage }}
      </app-alert>
    </div>

    <div class="mt-8 pb-8">
      <form [formGroup]="form" autocomplete="off" (submit)="submit()">
        <div class="mb-4">
          <app-input
            type="email"
            controlSize="large"
            id="email"
            aria-describedby="emailHelp"
            placeholder="Email or Username"
            autocomplete="off"
            required
            formControlName="email"
            [errors]="errors?.email"
          ></app-input>
        </div>

        <div class="mb-4">
          <app-input
            type="password"
            controlSize="large"
            id="password"
            placeholder="Password"
            autocomplete="off"
            required
            formControlName="password"
            [errors]="errors.password"
          ></app-input>
        </div>

        <div class="my-4">
          <app-button
            expand="block"
            [loading]="loading"
            size="large"
            type="submit"
          >
            Sign In
          </app-button>
        </div>

        <p class="mt-8">
          Forgot your password?
          <a routerLink="/forgot-password"
            >Reset it<i class="app-icon-chevron-right align-middle"></i
          ></a>
        </p>

        <hr class="mt-4" />

        <p class="mt-4">
          Don't have an account?
          <a routerLink="/sign-up"
            >Sign up now<i class="app-icon-chevron-right align-middle"></i
          ></a>
        </p>
      </form>
    </div>
  </div>
</div>
